(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      if (!reduced.matches) entry.target.classList.add('at-revealed');
      observer.unobserve(entry.target);
    }
  }, {threshold: 0.08}) : null;
  const init = (root = document) => {
    root.querySelectorAll('[data-at-reveal], .resource-list__item').forEach(el => {
      if (seen.has(el)) return;
      seen.add(el);
      if (observer) observer.observe(el);
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:cart:lines-update', () => {
    if (reduced.matches) return;
    document.querySelectorAll('.cart-bubble__text, .theme-drawer__badge').forEach(el => {
      el.classList.remove('at-count-change');
      requestAnimationFrame(() => {
        el.classList.add('at-count-change');
        el.addEventListener('animationend', () => el.classList.remove('at-count-change'), {once:true});
      });
    });
  });
  document.addEventListener('shopify:section:unload', event => {
    if (!observer) return;
    event.target.querySelectorAll('[data-at-reveal], .resource-list__item').forEach(el => observer.unobserve(el));
  });
})();
